/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Block1_H3Inputs */

const es_landing_price_block1_h3 = /** @type {(inputs: Landing_Price_Block1_H3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para empezar, una sola vez.`)
};

const gl_landing_price_block1_h3 = /** @type {(inputs: Landing_Price_Block1_H3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para comezar, unha soa vez.`)
};

const en_landing_price_block1_h3 = /** @type {(inputs: Landing_Price_Block1_H3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To get started, just once.`)
};

/**
* | output |
* | --- |
* | "To get started, just once." |
*
* @param {Landing_Price_Block1_H3Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_block1_h3 = /** @type {((inputs?: Landing_Price_Block1_H3Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Block1_H3Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_block1_h3(inputs)
	if (locale === "en") return en_landing_price_block1_h3(inputs)
	return es_landing_price_block1_h3(inputs)
});